<script lang="ts" setup>
  import type { PropType } from 'vue';
  import type { Photo } from '@storefront/resources';

  type Item = {
    header: string | null;
    headerType: string;
    content: string | null;
    photos: Photo[];
  }

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    items: { type: Array as PropType<Item[]>, required: true, default: [] },
    header: String,
    headerType: String,
  });
</script>
<template>
  <SfSection :title="header" :headerType v-if="items.length > 0">
    <div class="about-tiles">
      <article v-for="item in items" class="about-tiles__tile">
        <MediaPicture :photo="item.photos?.[0]" type="photo" sizes="1112x834 2x max 576, 556x417 max 576, 884x664 2x max 992, 442x332 max 992, 860x646 2x, 430x323" />
        <SfHeading v-if="item.header" :type="item.headerType ?? 'h3'" v-html="item.header" class="about-tiles__heading" />
        <QuillContent v-if="item.content" :content="item.content" />
      </article>
    </div>
  </SfSection>
</template>
<style lang="scss" scoped>
  .about-tiles {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;

    &__tile {
      display: flex;
      flex-direction: column;

      :deep(.ql-editor) {
        padding: 0;
      }
    }

    &__heading {
      margin: 1rem 0 0.25rem;
    }

    @media (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
      padding: 0 0.625rem;

      &__heading {
        margin: 0.5rem 0 0;
      }
    }

    @media(max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }
</style>
